<div *ngIf="value">
  <ms-odonto-odontogram name="odonto-odontogram__{{turn}}" [turn]="turn" [(ngModel)]="value.odontogramView"
    [symbology]="value.symbology" *ngIf="!isFirst">
  </ms-odonto-odontogram>

  <ms-odonto-therapy name="odonto-therapy__{{turn}}" [turn]="turn" [(ngModel)]="value.therapy"
    [therapies]="value.therapies!" *ngIf="!isFirst">
  </ms-odonto-therapy>

  <hr *ngIf="!isFirst" />

  <ms-odonto-top-bottom-questions name="odonto-questions_top__{{turn}}" [turn]="turn"
    [(ngModel)]="value.topQuestions"></ms-odonto-top-bottom-questions>

  <ms-odonto-subject name="odonto-subject__{{turn}}" [turn]="turn" [(ngModel)]="value.detail.subject"
    *ngIf="value.detail">
  </ms-odonto-subject>

  <ms-odonto-disease name="odonto-disease__{{turn}}" [turn]="turn" [(ngModel)]="value.detail.disease"
    *ngIf="value.detail">
  </ms-odonto-disease>

  <ms-odonto-history name="odonto-history__{{turn}}" [turn]="turn" [(ngModel)]="value.historyView">
  </ms-odonto-history>

  <ms-odonto-header name="odonto-header__{{turn}}" [turn]="turn" [(ngModel)]="value.header">
  </ms-odonto-header>

  <ms-odonto-stomatognathic name="odonto-stomatognathic__{{turn}}" [turn]="turn" [(ngModel)]="value.stomatognathicView">
  </ms-odonto-stomatognathic>

  <ms-odonto-odontogram name="odonto-odontogram__{{turn}}" [turn]="turn" [(ngModel)]="value.odontogramView"
    [symbology]="value.symbology" *ngIf="isFirst">
  </ms-odonto-odontogram>

  <ms-odonto-oral-health name="odonto-oral-health__{{turn}}" [turn]="turn" [(ngModel)]="value.oralHealth"
    [(hygiene)]="value.oralHygieneView" *ngIf="value.oralHealth">
  </ms-odonto-oral-health>

  <ms-odonto-diagnostic-plan name="odonto-diagnostic-plan__{{turn}}" [turn]="turn"
    [(ngModel)]="value.diagnosticPlanView"></ms-odonto-diagnostic-plan>

  <ms-odonto-diagnostic name="odonto-diagnostic__{{turn}}" [turn]="turn" [patient]="patient"
    [(ngModel)]="value.diagnosticView">
  </ms-odonto-diagnostic>

  <ms-odonto-additional-information name="odonto-additional__{{turn}}" [turn]="turn"
    [(ngModel)]="value.detail.additionalInformation" *ngIf="value.detail">
  </ms-odonto-additional-information>

  <ms-odonto-therapy name="odonto-therapy__{{turn}}" [turn]="turn" [(ngModel)]="value.therapy" *ngIf="isFirst">
  </ms-odonto-therapy>

  <ms-odonto-top-bottom-questions name="odonto-questions-bottom__{{turn}}" [turn]="turn"
    [(ngModel)]="value.bottomQuestions"></ms-odonto-top-bottom-questions>
</div>
